
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#FFF","cx":"10","cy":"10","r":"10"}}),_c('path',{attrs:{"d":"M8.905 13.374c0-.694.558-1.197 1.265-1.197.721 0 1.293.503 1.293 1.197 0 .694-.572 1.211-1.293 1.211-.707 0-1.265-.517-1.265-1.21zM13 8.504c0 1.02-.762 1.686-1.333 2.394-.313.367-.381.585-.395.79H9.163c.014-.49.15-.804.667-1.443.49-.599.952-.98.952-1.524 0-.462-.313-.762-.762-.762-.517 0-.789.395-.816.83H7C7.163 7.24 8.224 6 10.102 6 11.844 6 13 6.952 13 8.503z","fill":"#F26522"}})])])
      }
    
      }
    